var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from '@glimmer/tracking';
var Status = /*#__PURE__*/function (Status) {
  Status[Status["UPLOADED"] = 0] = "UPLOADED";
  Status[Status["PENDING"] = 1] = "PENDING";
  Status[Status["FAILED"] = 2] = "FAILED";
  return Status;
}(Status || {});
let Attachment = (_class = class Attachment {
  constructor(name, size, url, file, id, contentType, status, errorMessage) {
    _initializerDefineProperty(this, "id", _descriptor, this);
    _initializerDefineProperty(this, "contentType", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "size", _descriptor4, this);
    _initializerDefineProperty(this, "url", _descriptor5, this);
    _initializerDefineProperty(this, "errorMessage", _descriptor6, this);
    _initializerDefineProperty(this, "retryable", _descriptor7, this);
    _initializerDefineProperty(this, "status", _descriptor8, this);
    _defineProperty(this, "file", void 0);
    this.name = name;
    this.size = size;
    this.url = url;
    this.file = file;
    this.id = id;
    this.contentType = contentType;
    if (status) {
      this.status = status;
    } else if (this.url) {
      this.status = Status.UPLOADED;
    } else {
      this.status = Status.PENDING;
    }
    if (errorMessage) {
      this.errorMessage = errorMessage;
    }
  }
  static fromFile(file) {
    return new Attachment(file.name, file.size, undefined, file, undefined, file.type);
  }
  static fromBlockAttachment(blockAttachment) {
    let id = 'attachmentId' in blockAttachment ? blockAttachment.attachmentId : blockAttachment.id;
    return new Attachment(blockAttachment.name, blockAttachment.size, blockAttachment.url, undefined, id, blockAttachment.contentType, blockAttachment.status, blockAttachment.errorMessage);
  }
  get isUploaded() {
    return this.status === Status.UPLOADED;
  }
  get isPending() {
    return this.status === Status.PENDING;
  }
  get isFailed() {
    return this.status === Status.FAILED;
  }
  get asBlockAttachment() {
    return {
      id: this.id,
      contentType: this.contentType,
      name: this.name,
      size: this.size,
      url: this.url
    };
  }
  markAsPending() {
    this.status = Status.PENDING;
  }
  updateWithUploadResult(uploadResult) {
    if (uploadResult.type === 'success') {
      this.url = uploadResult.uploadUrl;
      this.status = Status.UPLOADED;
      this.id = uploadResult.id;
      this.contentType = uploadResult.contentType;
    } else {
      this.errorMessage = uploadResult.reason;
      this.retryable = uploadResult.retryable;
      this.status = Status.FAILED;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "contentType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "size", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "url", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "retryable", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "status", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { Attachment as default };